import { Button, Typography } from '@mui/material';
import { StyledCenterBox } from '../Home.styled';
import HomeSection from '../HomeSection';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import React from 'react';
const ProviderPricesSection: React.FC = () => {
  return (
    <>
      <HomeSection
        content={
          <StyledCenterBox>
            <Typography variant="subtitle1">
              All the prices at a glance – find your perfect subscription!
            </Typography>{' '}
            <br />
            <a href="/providerprices">
              <Button variant="outlined" color="secondary">
                Compare prices
              </Button>
            </a>
          </StyledCenterBox>
        }
        title={
          <>
            <PriceCheckIcon color="primary" />
            Start saving
          </>
        }
        buttonTitle="Priceoverview"
        linkTo="/providerprices"
      />{' '}
    </>
  );
};
export default ProviderPricesSection;
